import * as React from 'react';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import State from '../../application/core/State';
import CustomersRequested from '../../application/admin/events/CustomersRequested';
import Client from './Client';
import './Clients.css';
import Customer from '../../domain/Customer';

interface StateProps {
    customers: Customer[];
}

class Clients extends React.PureComponent<StateProps & DispatchProps> {
    public componentDidMount(): void {
        this.props.dispatch(new CustomersRequested());
    }

    public render(): JSX.Element {
        return (
            <div className="clients">
                <div className="clients-container">
                    <h1>Customers</h1>
                    <div className="clients-list">
                        {this.props.customers.map((client: Customer) => {
                            return <Client client={client} key={client.customerId} />;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: State): StateProps => ({
    customers: state.admin.customers
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Clients);



// WEBPACK FOOTER //
// ./src/view/admin/Clients.tsx